__turbopack_context__.v({
  "centered": "Box-module__-XCm1W__centered",
  "container": "Box-module__-XCm1W__container",
  "flex": "Box-module__-XCm1W__flex",
  "fullHeight": "Box-module__-XCm1W__fullHeight",
  "padding": "Box-module__-XCm1W__padding",
  "paddingBottom": "Box-module__-XCm1W__paddingBottom",
  "paddingHorizontal": "Box-module__-XCm1W__paddingHorizontal",
  "paddingLeft": "Box-module__-XCm1W__paddingLeft",
  "paddingRight": "Box-module__-XCm1W__paddingRight",
  "paddingTop": "Box-module__-XCm1W__paddingTop",
  "paddingVertical": "Box-module__-XCm1W__paddingVertical",
});
